/*global BMap BMapLib*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import classnames from "classnames";
import "./index.sass";
import "./marker.sass";

import { MapStore, AppStore } from "@store/";

import { myConst, myFn, myMap } from "@config/";
import { init, pin, getMyLocInit, initEvent } from "./utils";



myFn.init = init; // 初始化, watch 后触发
myFn.pin = pin; // 打点Marker函数挂到全局，便于 watch 后触发

@inject(stores => ({
    appStore: stores.appStore,
    mapStore: stores.mapStore,
}))
@observer
class Map extends Component {
    constructor(props) {
        super(props);
        this.$refs = {};
    }
    componentDidMount() {
        this.initMap();
    }
    initMap = () => {
        const mapStore = this.props.mapStore;
        // 初始化参数
        mapStore.defaultLoc.bLoc = new BMap.Point(mapStore.defaultLoc.lng, mapStore.defaultLoc.lat);
        mapStore.myLoc.bLoc = new BMap.Point(mapStore.myLoc.lng, mapStore.myLoc.lat);

        // 图开始初始化
        myMap.map = new BMap.Map(this.$refs.map, {
            enableHighResolution: true,
            enableMapClick: false,
        });
        myMap.map.enableScrollWheelZoom();
        // 注册控件
        // 切换卫星地图
        myMap.map.addControl(new BMap.MapTypeControl({
            type: BMAP_MAPTYPE_CONTROL_MAP, // eslint-disable-line
            anchor: BMAP_ANCHOR_TOP_RIGHT, // eslint-disable-line
        }));
        // 放大缩小控件 + -
        myMap.map.addControl(new BMap.NavigationControl({
            anchor: BMAP_ANCHOR_BOTTOM_RIGHT, // eslint-disable-line
            offset: new BMap.Size(10, Math.floor(window.innerHeight / 2 - 50)),
        }));
        // 初始化弹窗组件
        mapStore.win.infoBox = new BMapLib.InfoBox(myMap.map, myConst.infoHtml, {
            enableMassClear: false,
            enableAutoPan: true,
            align: INFOBOX_AT_TOP, // eslint-disable-line
            offset: new BMap.Size(0, 40), // 窗口网上移动 三角形的偏移量
            boxStyle: {
                width: "200px",
                // background: "#ccc",
                // textAlign: 'center'
            },
            boxClass: "infoBoxWrap",
            closeIconMargin: "1px 11px 0 0", // 26是计算了 infoBoxWrap 的 padding边框 0px偏移量  10+0+1
            closeIconUrl: './static/img/close.png',
        });
        mapStore.win.infoBox.addEventListener('close', (event) => {
            mapStore.toggleInfoBox({ on_off: false, source: 'close event' });
        });

        myMap.map.addEventListener('resize', () => {
            myMap.map.centerAndZoom(myMap.map.getCenter(), myMap.map.getZoom());
        });

        function mapLoad(params) {
            mapStore.mapIsOk();
            myMap.map.removeEventListener('load', mapLoad);
        }
        myMap.map.addEventListener('load', mapLoad);
        // 开始初始化地图
        myMap.map.centerAndZoom(mapStore.defaultLoc.bLoc, 16);
        initEvent();
        // 定位
        getMyLocInit();
    }

    render() {
        const stateClass = classnames({
            markerShowEmpty: this.props.appStore.appState.UseOrEmpty,
            hideMarkerText: this.props.mapStore.mapPageState.hideMarkerText,
        });
        return (
            <div id="map" className={stateClass}>
                <div ref={(elm) => { this.$refs.map = elm; }}> </div>
                <div id="marker_center">
                    <img src={require("./lollipop.png")} alt="" />
                </div>
            </div>
        );
    }
}


Map.wrappedComponent.propTypes = {
    appStore: PropTypes.instanceOf(AppStore).isRequired,
    mapStore: PropTypes.instanceOf(MapStore).isRequired,
};
export default Map;